import { createSelector } from "@reduxjs/toolkit";
import { errorsAdapter } from "@src/store/errors/errors-slice";

/**
 * Returns all the errors
 */
export const errorFlagsSelector = createSelector(state => state.errors, errorsState => {
  return errorsAdapter.getSelectors().selectAll(errorsState);
});